// extracted by mini-css-extract-plugin
export var createdDate = "_ne-1";
export var divider = "_ne-2";
export var headerDivider = "_ne-3";
export var messagesCard = "_ne-0";
export var messagesContainer = "_ne-6";
export var messagesContainerWrapper = "_ne-4";
export var showLeftPanelButton = "_ne-8";
export var topButtons = "_ne-7";
export var withPadding = "_ne-5";